/**
 * API Endpoint Constants — MangoTV
 * Pattern: mirrors glotv apis.js
 *
 * CRM endpoints use getCrmApiUrl() + operator_uid from localStorage
 * Client endpoints use getClientApiUrl() (dynamic, fetched from CRM landing)
 */

import { getCrmApiUrl } from "../config/apiConfig";
import { DEFAULT_OPERATOR } from "../../utils/operators";

// Helper: get current operator UID from localStorage or default
const getOperatorUid = () => {
  try {
    const stored = localStorage.getItem("mango_selected_operator");
    if (stored) return JSON.parse(stored).operator_uid;
  } catch {
    // ignore parse errors
  }
  return DEFAULT_OPERATOR.operator_uid;
};

// ==============================================================================
// CRM API ENDPOINTS (OTP, Subscriber, Auth verification)
// ==============================================================================

export const generateOTPAPI = () => {
  return `${getCrmApiUrl()}/otp/?operator_uid=${getOperatorUid()}&mode=generate`;
};

export const validateOTPAPI = () => {
  return `${getCrmApiUrl()}/otp/?operator_uid=${getOperatorUid()}&mode=validate`;
};

export const signUpAPI = () => {
  return `${getCrmApiUrl()}/subscriber/?operator_uid=${getOperatorUid()}`;
};

export const fetchUserAPI = () => {
  return `${getCrmApiUrl()}/subscriber/?limit=30`;
};

export const resetPasswordAPI = () => {
  return `${getCrmApiUrl()}/subscriber/?`;
};

export const networkVerifyAPI = (username) => {
  return `${getCrmApiUrl()}/auth/?operator_uid=${getOperatorUid()}&usr=${username}`;
};

export const logAPI = () => {
  return `${getCrmApiUrl()}/logs/?operator_uid=${getOperatorUid()}`;
};

// ==============================================================================
// CLIENT API ENDPOINTS (Login, Content, Streaming)
// These are relative paths — used with getClientApiUrl() as base
// ==============================================================================

export const AUTH_ENDPOINTS = {
  LOGIN_V2: "/api/client/v2/global/login",
  LOGIN_V1: "/api/client/v1/global/login",
  REFRESH_V2: "/api/client/v2/global/refresh",
  REFRESH_V1: "/api/client/v1/global/refresh",
  LOGOUT: "/api/client/v1/global/logout",
};

export const USER_ENDPOINTS = {
  PROFILE: "/api/client/v2/global/profile",
  UPDATE_PROFILE: "/api/client/v2/global/profile/update",
  DEVICES: "/api/client/v2/global/devices",
};

export const CONTENT_ENDPOINTS = {
  MOVIES: "/api/client/v2/movies",
  SERIES: "/api/client/v2/series",
  LIVE_TV: "/api/client/v2/livetv",
  SEARCH: "/api/client/v2/search",
  GENRES: "/api/client/v2/genres",
};

export const SUBSCRIPTION_ENDPOINTS = {
  PACKAGES: "/api/client/v2/packages",
  SUBSCRIBE: "/api/client/v2/subscribe",
  HISTORY: "/api/client/v2/subscription-history",
  ACTIVE: "/api/client/v2/active-subscription",
};
